export enum MainMenuItemEnum {
  DataTracking = 'Data Tracking',
  DataAnalytics = 'Data Analytics',
  Reports = 'Reports',
  WorkflowManagement = 'Workflow Management',
  Alerts = 'Alerts',
  ApplicationManagement = 'Application Management',
  UserManagement = 'User Management'
}
